import { useCallback } from 'react';
import classNames from 'classnames';
import { Input } from '@mui/material';
import searchIcon from '../../../images/search-icon.svg';
import './RewardsSearchInput.scss';
import useSearchPlaceHolderText from '../../../../../hooks/useSearchPlaceHolderText';
import useRewardsV2Flag from '../../../utils/hooks/useRewardsV2Flag';

const RewardsSearchInput = ({
  setIsSearching,
  clearFiltersAndResults,
  searchType,
}) => {
  const placeHolderText = useSearchPlaceHolderText(searchType);
  const rewardsV2Enabled = useRewardsV2Flag();

  const onOpenModal = useCallback(() => {
    setIsSearching();
    clearFiltersAndResults();
  }, []);

  return (
    <div className={classNames(
      'RewardsSearchInput__input-container',
      { 'RewardsSearchInput__rewards-v2': rewardsV2Enabled },
    )}
    >
      <Input
        className="RewardsSearchInput__input"
        placeholder={placeHolderText}
        onClick={onOpenModal}
        disableUnderline
        readOnly
      />
      <img
        className="RewardsSearchInput__search-icon"
        src={searchIcon}
        alt="search-icon"
      />
    </div>

  );
};

export default RewardsSearchInput;
